export default {
    state: {
        aiContinuousTipFlag: true, //更改连续对话文案，true包含ai点数消耗
        aiConsumePointsVisble: true, // 是否显示AI消耗点数tips
        aiConsumePointsText: "",
        aiPointsDialogFlag: false, // ai点数不足弹窗，true使用外链页面
        aiPointsDialogWidth: 512,
        aiPointsDialogHeight: 406,
    },
    getters: {},
    mutations: {
        setStaticConfigState(state, obj) {
            let keys = Object.keys(obj);
            for (let item of keys) {
                state[item] = obj[item];
            }
        },
    },
};
